/**
 * Browser and Vite messages raised when a hashed JS/CSS chunk is missing.
 * The URL (and therefore the build hash) changes every deploy, so grouping
 * must key off these stable phrases rather than the full message.
 */
const CHUNK_LOAD_MESSAGE_PATTERNS: readonly RegExp[] = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Failed to load module script/i,
  /Expected a JavaScript-or-Wasm module script/i,
  /Unable to preload CSS/i,
];

export const chunkLoadErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message;
  }
  return undefined;
};

export const isChunkLoadErrorMessage = (
  message: string | undefined
): boolean => {
  if (!message) {
    return false;
  }
  return CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
};

export const isChunkLoadError = (error: unknown): boolean =>
  isChunkLoadErrorMessage(chunkLoadErrorMessage(error));
